export default {
  rewriteRoute: {
    path: '/rebate/detail',
    name: 'rebateDetail',
  },
}
